// extracted by mini-css-extract-plugin
export default {"UpscaleListContent":"Components_UpscaleListContent__aKm0i","UpscaleListHead":"Components_UpscaleListHead__Dw-II"};